import React, { FC, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'

import { generalActions } from 'src/actions/GeneralActions'
import { profileActions } from 'src/actions/ProfileActions'
import { GeoModel } from 'src/dataSources/geo/GeoModel'
import { RootState } from 'src/Store'

import { modelPickerStyle } from './ModelPicker.style'

export interface ModelPickerProps {} // eslint-disable-line @typescript-eslint/no-empty-interface

const defaultProps: ModelPickerProps = {
}

export const ModelPicker: FC<ModelPickerProps> = (props: ModelPickerProps) => {
  const classes = modelPickerStyle()
  const dispatch = useDispatch()
  const tokenSelector = useSelector((state: RootState) => state.authState.token)
  const models = useSelector((state: RootState): GeoModel[] | undefined => state.generalState.geoModels)
  const selectedGeoModel = useSelector((state: RootState): GeoModel | undefined => state.generalState.selectedGeoModel)

  useEffect(() => {
    if (tokenSelector === '') {
      return
    }
    dispatch(generalActions.fetchGeoModels(undefined, undefined))
    // eslint-disable-next-line
  }, [tokenSelector])

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>): void => {
    if (models === undefined) {
      return
    }
    const modelId = event.target.value as string
    if (modelId === 'default') {
      dispatch(profileActions.clearState())
      dispatch(generalActions.setSelectedGeoModel(undefined))
    } else {
      for (const model of models) {
        if (model.ID === modelId) {
          dispatch(generalActions.setSelectedGeoModel(model))
          break
        }
      }
    }
  }

  return (
    <div className={classes.root}>
      <FormControl className={classes.formControl}>
        <InputLabel shrink id='model-id-label' className={classes.modelLabel}><FormattedMessage id='toolbar.model' /></InputLabel>
        <Select
          labelId='model-id-label'
          id='model-id'
          value={selectedGeoModel !== undefined ? selectedGeoModel.ID : 'default'}
          onChange={handleChange}
          displayEmpty
          className={classes.modelSelect}
          disableUnderline
        >
          <MenuItem key='default' value='default'><FormattedMessage id='models.default' /></MenuItem>
          {models?.map((geoModel: GeoModel, index: number) => {
            return (
              <MenuItem key={index} value={geoModel.ID}>{geoModel.Name}</MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </div>
  )
}

ModelPicker.defaultProps = defaultProps

export default ModelPicker
